import { render, staticRenderFns } from "./MInternalAdvertiserIssue.vue?vue&type=template&id=1af9452a&scoped=true&lang=pug&"
import script from "./MInternalAdvertiserIssue.vue?vue&type=script&lang=js&"
export * from "./MInternalAdvertiserIssue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af9452a",
  null
  
)

export default component.exports